import { Component, Input, OnDestroy, type OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IInvestmentLine, IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { LIFE_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS, life_change_investment_line_form_keys } from './change-investment-line-isv.constants';

@Component({
  selector: 'app-change-investment-line-isv',
  templateUrl: './change-investment-line-isv.component.html',
  styleUrl: './change-investment-line-isv.component.scss',
})
export class ChangeInvestmentLineIsvComponent implements OnInit, OnDestroy {

  @Input() form: FormGroup;
  @Input('assets')
  set _assets(val: IInvestmentLine[]) {
    if (val && val.length > 0) {
      this.manageFunds(val);
    }
  }
  @Input() operationCost: number;
  @Input() operationEffectDate: string; 
  assets: IInvestmentLine[] = [];
  lineAssets: IPolicyAsset[] = [];
  keys: IFormKey[] = CommonUtils.assign(life_change_investment_line_form_keys);
  tableKeys: ITableKey[] = CommonUtils.assign(LIFE_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS);
  actualInvestmentLineCode: string = '';
  actualInvestmentLineDescription: string = '';
  destroy$ = new Subject();

  ngOnInit(): void {
    this.form.controls['line'].valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
        this.updateLineAssets(value);
    })
    if (this.form.controls['line'].value) {
        this.updateLineAssets(this.form.controls['line'].value);
    }
  }

  formatAmount(value: number | string): string {
    return value.toString().replace('.', ',');
  }

    private updateLineAssets(selectedLineCode: string): void {
        if (!selectedLineCode) {
            this.lineAssets = [];
            return;
        }

        const selectedIndex = this.assets.findIndex(x => x.code === selectedLineCode);
        const currentIndex = this.assets.findIndex(x => x.code === this.actualInvestmentLineCode);

        this.actualInvestmentLineCode = this.assets[selectedIndex].code;
        this.assets[selectedIndex].selected = true;
        this.assets[currentIndex].selected = false;
        const selectedLine = this.assets[selectedIndex];
        const currentInvestmentLine = this.assets[currentIndex];
        if (selectedIndex < 0) {
            this.lineAssets = [];
            return;
        }

        const currentFunds = currentInvestmentLine?.funds || [];
        const funds = selectedLine.funds;

        this.lineAssets = funds.map(selectedFund => {
            const currentFund: IPolicyAsset | undefined = currentFunds.find(x => x.fundCode === selectedFund.fundCode);

            const currentAmount = this.formatAmount(currentFund?.fundAmount || 0);
            const futureAmount = this.formatAmount(selectedFund.fundAmount || 0);

            const diff = (currentFund?.fundAmount || 0) - (selectedFund.fundAmount || 0);

            return {
                fundCode: selectedFund.fundCode,
                description: selectedFund.description,
                fundAmount: currentAmount,
                futureFundAmount: futureAmount,
                differenceAmount: this.formatAmount(parseFloat(diff.toFixed(2))),
            };
        });
    }
  get lineFormKey(): IFormKey {
    return this.keys.find(x => x.controlName === 'line');
  }

  manageFunds(assets: IInvestmentLine[]) {
    this.assets = assets;
    this.actualInvestmentLineCode = assets?.find(x => x.selected).code
    this.actualInvestmentLineDescription = assets?.find(x => x.selected).description || '';
    this.lineFormKey.options = assets?.filter(x => x.code !== this.actualInvestmentLineCode).map(x => ({
      key: x.code,
      value: x.description
    }));
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
